function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/X-Close/M/Default"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.41,12 L17.71,7.71 C18.1021222,7.31787783 18.1021222,6.68212217 17.71,6.29 C17.3178778,5.89787783 16.6821222,5.89787783 16.29,6.29 L12,10.59 L7.71,6.29 C7.31787783,5.89787784 6.68212218,5.89787784 6.29000001,6.29000001 C5.89787784,6.68212218 5.89787784,7.31787783 6.29,7.71 L10.59,12 L6.29,16.29 C6.10068735,16.4777666 5.99420168,16.7333625 5.99420168,17 C5.99420168,17.2666375 6.10068735,17.5222334 6.29,17.71 C6.4777666,17.8993127 6.73336246,18.0057983 7,18.0057983 C7.26663754,18.0057983 7.5222334,17.8993127 7.71,17.71 L12,13.41 L16.29,17.71 C16.4777666,17.8993127 16.7333625,18.0057983 17,18.0057983 C17.2666375,18.0057983 17.5222334,17.8993127 17.71,17.71 C17.8993127,17.5222334 18.0057983,17.2666375 18.0057983,17 C18.0057983,16.7333625 17.8993127,16.4777666 17.71,16.29 L13.41,12 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
})));

function SvgIconXCloseDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXCloseDefault);
export default __webpack_public_path__ + "static/media/icon_x_close_default.d673b1cc.svg";
export { ForwardRef as ReactComponent };